const header = document.getElementsByClassName( 'sticky-header' )[ 0 ];
const position = 0; // or header.offsetTop

function stickyHeader() {
  if ( window.pageYOffset > position ) {
    header.classList.add( 'header-sticked' );
  } else {
    header.classList.remove( 'header-sticked' );
  }
}

if ( header ) {
  window.onscroll = function() {
    stickyHeader();
  };
}
